import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AppLayout, LoginLayout} from 'features/navigation/Layouts';
import {ensureSessionOrRedirect} from '../../helpers/session';

export const AppRoute = ({component: Component, ...props}) => {
  if (!ensureSessionOrRedirect()) {
    return <Redirect to="/login" />;
  }

  const requiresPasswordChange =
    sessionStorage.getItem('requirePasswordChange') === 'true';
  const path = props?.path;
  const isChangePasswordPath =
    path === '/change-password' ||
    (Array.isArray(path) && path.includes('/change-password'));

  if (requiresPasswordChange && !isChangePasswordPath) {
    return <Redirect to="/change-password" />;
  }

  return (
    <Route
      {...props}
      render={(matchProps) => (
        <AppLayout>
          <Component {...matchProps} />
        </AppLayout>
      )}
    />
  );
};

export const LoginRoute = ({component: Component, ...props}) => (
  <Route
    {...props}
    render={(matchProps) => (
      <LoginLayout>
        <Component {...matchProps} />
      </LoginLayout>
    )}
  />
);
